module.exports = __webpack_public_path__ + "img/product.b7db7ba0.png";